enum FieldType {
  DATE = 'date',
  NUMBER = 'number',
  TABLE = 'table',
  TEXT = 'text',
}

enum FieldJobType {
  CARRIER_ACCESS_COMPLETED = 'carrier_access_verification_completed',
  CARRIER_ACCESS_STARTED = 'carrier_access_verification_started',
  CLEANING_LLM = 'kay_core_llm_cleaning',
  CUSTOM = 'kay_core_custom',
  CUSTOMER_CONFIRMATION = 'kay_core_customer_confirmation',
  EMAIL_REPLY = 'kay_core_email_reply',
  EMAIL_SCHEMA_EXTRACTION = 'kay_core_email_schema_extraction',
  EXTRACTION_LLM = 'kay_core_llm_extraction',
  EXTRACTION_VQA = 'kay_core_vqa_extraction',
  FORM_AGENT = 'kay_core_form_agent',
  HUMAN_IN_THE_LOOP = 'kay_core_human_in_the_loop',
  PREREQUISITE_VALIDATION = 'kay_core_prerequisite_validation',
  REMOVE_CHARACTERS = 'kay_core_remove_characters',
  VALIDATION_CONFIDENCE = 'kay_core_confidence_validation',
  VALIDATION_RULE = 'kay_core_validation',
  VISUAL_EXTRACTION = 'kay_core_visual_extraction',
}

enum FieldComponentType {
  EXTRACTION = 'extraction',
  VALIDATION = 'document_validation',
}

enum DocFileState {
  INGESTING = 'ingesting',
  PENDING_CLASSIFICATION = 'pending_classification',
  READY = 'ready',
}

type WorkflowDocument = {
  created_at: string;
  document_classes: DocumentClass[];
  document_id: string;
  document_name: string;
  document_state: DocFileState;
  updated_at: string;
};

type DocumentClass = {
  class_description: string;
  class_id: string;
  class_name: string;
  class_type: string;
  created_at: string;
  fields: DocumentField[];
  updated_at: string;
};

type FieldJob = {
  created_at: string;
  dependencies: Record<string, any>;
  job_args: Record<string, any>;
  job_id: string;
  job_name: string;
  job_type: FieldJobType;
  queries: Record<string, any>;
  tags: string[];
  updated_at: string;
};

type FieldComponent = {
  component_name: string;
  component_type: FieldComponentType;
  field_component_id: string;
  jobs: FieldJob[];
};

type DocumentField = {
  components: FieldComponent[];
  field_id: string;
  field_name: string;
  field_type: FieldType;
  jobs: FieldJob[];
};

export type { WorkflowDocument, DocumentClass, FieldJob, FieldComponent, DocumentField };

export { DocFileState, FieldType, FieldJobType, FieldComponentType };
